// extracted by mini-css-extract-plugin
export default {"page":"O4-z","cartModal":"P4-z","checkout":"Q4-z","placeholder":"R4-z","account":"S4-z"};